<template>
  <div class='contentbox'>
    <a-card :bordered='false'>

      <div class='table-page-search-wrapper'>

        <a-form layout='inline' @keyup.enter.native='searchQuery'>
          <a-row :gutter='24'>
            <a-col :span='8'>
              <a-form-item :label="'日期'" :labelCol='{span: 6}' :wrapperCol='{span: 14, offset: 1}'>
                <a-range-picker
                  v-model='queryParam.dataDt'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
            <a-col :span='16'>
              <a-button style='margin-left: 20px' type='primary' @click='lookSevenDays'>查看当天数据</a-button>
              <a-button style='margin-left: 20px' type='primary' @click='lookTwoWeeks'>查看近3天数据</a-button>
              <a-button style='margin-left: 20px' type='primary' @click='lookOneMonth'>查看近7天数据</a-button>

            </a-col>
          </a-row>
          <a-row :gutter='24'>
            <a-col :md='10' :sm='8'>
              <a-form-item :label="'产品类型'">
                <a-select
                  v-model='queryParam.productRiskNo'
                  @change='handleChangeproductRiskNo'
                  mode='multiple'
                >
                  <a-select-option v-for='item in appNameList' :key='item'>
                    {{ item }}
                  </a-select-option>
                </a-select>

              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='8'>
              <a-form-item :label="'用户类型'">
                <a-select default-value='' style='width: 120px' v-model='queryParam.custType'>
                  <a-select-option value=''>
                    全部
                  </a-select-option>
                  <a-select-option value='1'>
                    新户
                  </a-select-option>
                  <a-select-option value='2'>
                    老户
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='6'>
              <a-form-item label="运营类型">
                <a-select default-value="" style="width: 120px" v-model="queryParam.proxyFlag">
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="0">
                    自运营
                  </a-select-option>
                  <a-select-option value="1">
                    代理运营
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter='24'>
            <a-col :md='6' :sm='8'>
              <a-form-item :label="'盘号'">
                <a-select
                  v-model='queryParam.appssid'
                  @change='selectproductNameChange'
                >
                  <a-select-option v-for='item in panhaoList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='8'>
              <a-form-item label="前收后收">
                <a-select default-value="" style="width: 120px" v-model="queryParam.receiptTimeFlag">
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="0">
                    前收
                  </a-select-option>
                  <a-select-option value="1">
                    后收
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='12' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
              <a-button type='primary' @click='searchReset' style='margin-left: 8px' icon='reload'>重置</a-button>
              <!--              <a-button type='primary' @click='downLoadData()' icon='download'-->
              <!--                        style='margin-left: 8px'>导出</a-button>-->
              <!--              <a-button type='primary' @click='downLoadData2()' icon='download'-->
              <!--                        style='margin-left: 8px'>导出2</a-button>-->
                <a-button type='primary' @click='VisualChart()' icon='bar-chart'
                          style='margin-left: 8px'>查看可视化图表
              </a-button>
            </span>
            </a-col>
          </a-row>
        </a-form>

        <a-table
          style='margin-top: 14px'
          ref='table'
          rowKey='id'
          size='middle'
          :columns='visibleColumns'
          :dataSource='dataSource'
          :pagination='false'
          :loading='loading'
          bordered
          @change='handleTableChange'>
        </a-table>
        <div style='margin-top: 15px; text-align: right;'>
          <v-pagination
            v-if='total'
            :page-num='form.pageNum'
            :page-size='form.pageSize'
            :total='total'
            @change='handleTableChange' />
        </div>

      </div>
      <RefundTradeModal ref='modalForm' @ok='modalFormOk'></RefundTradeModal>
      <!--页面跳转失败提示-->
      <!--      <a-modal-->
      <!--        title='操作提示'-->
      <!--        :visible='visible'-->
      <!--        :confirm-loading='confirmLoading'-->
      <!--        @ok='handleOk'-->
      <!--        @cancel='handleCancel'-->
      <!--      >-->
      <!--        <h3>{{ modalTipsValue }}</h3>-->
      <!--      </a-modal>-->
      <repaymentReportForProductModal ref='repaymentReportForProductModal'
                                      :paramsChartsData='paramsChartsData'></repaymentReportForProductModal>
    </a-card>

  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { repaymentReportForProduct, findAllProductRiskNo, getApplist } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { REFUND_TRADE_STATUS } from '@/constants/status'
import RefundTradeModal from './modules/RefundTradeModal'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'
import repaymentReportForProductModal
  from '@/views/webpublic/platformOrder/ChartsModal/repaymentReportForProductModal.vue'

export default {
  name: 'appNameList',
  components: {
    RefundTradeModal,
    Dict,
    repaymentReportForProductModal
  },

  data() {
    return {
      paramsChartsData: {},
      // modalTipsValue: '',//弹窗提示的内容
      // 弹窗
      confirmLoading: false,
      visible: false,
      REFUND_TRADE_STATUS,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,


      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      appNameList: [],
      panhaoList: [],
      // 查询条件
      queryParam: {
        receiptTimeFlag:'',
        appssid: '',
        dataDt: [moment().add('days', -6), moment().add('days', 0)],
        productRiskNo: [],
        custType: ''
      },
      loading: false,
      // 表头
      columns: [
        {
          title: '到期日期',
          align: 'left',
          dataIndex: 'endDate',
          customRender: (text, record, index) => {
            const obj = {
              children: text,
              attrs: {}
            }
            if (index === 0) {
              obj.attrs.rowSpan = this.getRowSpan(index, 'endDate')
            } else {
              if (record.endDate === this.dataSource[index - 1].endDate) {
                obj.attrs.rowSpan = 0
              } else {
                obj.attrs.rowSpan = this.getRowSpan(index, 'endDate')
              }
            }
            return obj
          },
          customCell: (record, rowIndex) => {
            let previousDate = this.dataSource[rowIndex - 1] ? this.dataSource[rowIndex - 1].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1

            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '产品名称', align: 'left', dataIndex: 'productRiskNo',
          customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【新户】放款用户数',
          align: 'left',
          dataIndex: 'firstLoanCustomerCount',
          customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【新户】还款用户数',
          align: 'left',
          dataIndex: 'firstRepaidCustomerCount',
          customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【新户】T1', align: 'left', dataIndex: 'firstT1', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【新户】d0', align: 'left', dataIndex: 'firstD0', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【新户】s', align: 'left', dataIndex: 'firstS', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【新户】回收率', align: 'left', dataIndex: 'firstRepaymentRate', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【新户】首次逾期率', align: 'left', dataIndex: 'firstOverdueRate', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【老户】放款用户数',
          align: 'left',
          dataIndex: 'oldLoanCustomerCount',
          customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【老户】还款用户数',
          align: 'left',
          dataIndex: 'oldRepaidCustomerCount',
          customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【老户】T-1', align: 'left', dataIndex: 'oldT1', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【老户】d0', align: 'left', dataIndex: 'oldD0', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【老户】s', align: 'left', dataIndex: 'oldS', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【老户】回收率', align: 'left', dataIndex: 'oldRepaymentRate', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        },
        {
          title: '【老户】逾期率', align: 'left', dataIndex: 'oldFirstOverdueRate', customCell: (record, rowIndex) => {
            let rowvalue = 0
            for (let item of this.dataSource) {
              if (record.endDate == item.endDate) {
                rowvalue += 1
              }
            }
            let previousDate = this.dataSource[rowIndex - rowvalue] ? this.dataSource[rowIndex - rowvalue].endDate : null
            let isSameAsPrevious = record.endDate === previousDate
            let isOddRow = !isSameAsPrevious && new Date(record.endDate).getDate() % 2 === 1
            return {
              style: {
                background: isOddRow ? '#f5f5f5' : '#ffffff'
              }
            }
          }
        }
      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    visibleColumns() {
      console.log('visibleColumns,this.queryParam.custType', this.queryParam.custType)
      if (this.queryParam.custType == 1) {
        console.log(111111111111111, this.columns)
        return this.columns.filter(column => column.dataIndex.startsWith('first') || column.dataIndex === 'endDate' || column.dataIndex === 'productRiskNo')
      } else if (this.queryParam.custType == 2) {
        console.log(2222222222222)
        return this.columns.filter(column => column.dataIndex.startsWith('old') || column.dataIndex === 'endDate' || column.dataIndex === 'productRiskNo')
      }
      console.log('用户类型选择的全部')
      return this.columns
    }
  },
  created() {
    console.log('进入了created')
    this.loadData()
    //产品名称
    findAllProductRiskNo().then(res => {
      console.log('findAllProductRiskNo', res)
      this.appNameList = res.data || []
    })
    //盘号
    getApplist().then(res => {
      this.panhaoList = res.data || []
    })
  },
  methods: {
    getRowSpan(index, key) {
      let count = 1
      for (let i = index + 1; i < this.dataSource.length; i++) {
        if (this.dataSource[index][key] !== this.dataSource[i][key]) {
          break
        }
        count++
      }
      return count
    },
    selectproductNameChange(val) {
      console.log('val---->', val)
    },
    lookSevenDays() {
      console.log('查看当天')
      this.queryParam.dataDt = [moment().add('days'), moment().add('days', 0)]
      this.loadData()
    },
    lookTwoWeeks() {
      console.log('查看3天')
      this.queryParam.dataDt = [moment().add('days', -2), moment().add('days', 0)]
      this.loadData()
    },
    lookOneMonth() {
      console.log('查看7天')
      this.queryParam.dataDt = [moment().add('days', -6), moment().add('days', 0)]
      this.loadData()
    },
    handleChangeproductRiskNo(value) {
      console.log(`Selected: ${value}`)
    },

    searchQuery() {
      this.loadData()
    },
    loadData() {
      // 加载数据 若传入参数1则加载第一页的内容
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      console.log('params原来是什么？？？？？', params)
      repaymentReportForProduct(Object.assign({}, params)).then((res) => {
        console.log('res打印结果----》', res)
        if (res.code === 1000) {
          this.total = res.data.rows.total
          this.dataSource = res.data.rows.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      console.log('lalala',this.queryParam)
      const { dataDt } = this.queryParam
      console.log('dataDt', dataDt)
      if (dataDt.length) { //不能都选
        this.paramsVal = {
          ...this.queryParam,
          startDate: dataDt && this.transformTime(dataDt[0]),
          endDate: dataDt && this.transformTime(dataDt[1])
        }
      } else {
        console.log('时间没筛选')
        this.paramsVal = {
          ...this.queryParam
        }
      }
      // 分页参数
      this.paramsVal.pageNum = this.form.pageNum
      this.paramsVal.pageSize = this.form.pageSize
      delete this.paramsVal.orderGenerationDate
      // return filterObj(this.paramsVal)
      return this.paramsVal
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    // handleTableChange(pagination, filters, sorter) {
    //   // TODO 筛选
    //   // if (Object.keys(sorter).length > 0) {
    //   //   this.isorter.column = sorter.field
    //   //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
    //   // }
    //   this.ipagination = pagination
    //   this.loadData()
    // },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    handleAdd() {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = '新增'
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.loadData()
      that.queryParam.productRiskNo = []
      that.queryParam.appssid = ''
      that.queryParam.custType = ''
      that.queryParam.receiptTimeFlag = ''
      that.queryParam.dataDt = [moment().add('days', -6), moment().add('days', 0)]

    },
    // model回调
    modalFormOk() {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    downLoadData(arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      var fileUrl = ''
      if (params.productRiskNo === undefined) {
        fileUrl = '/api/web/webpublic/statistics/appAllCountExcel?startDate=' + params.startDate + '&endDate=' + params.endDate
      } else {
        fileUrl = '/api/web/webpublic/statistics/appAllCountExcel?startDate=' + params.startDate + '&endDate=' + params.endDate + '&productRiskNo=' + params.productRiskNo
      }
      const file = {
        fileUrl: fileUrl,
        fileName: 'countLoanDataWithDateExcel.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    downLoadData2(arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      var fileUrl = ''
      if (params.productRiskNo === undefined) {
        fileUrl = '/api/web/webpublic/statistics/appAllCountExcel2?startDate=' + params.startDate + '&endDate=' + params.endDate
      } else {
        fileUrl = '/api/web/webpublic/statistics/appAllCountExcel2?startDate=' + params.startDate + '&endDate=' + params.endDate + '&productRiskNo=' + params.productRiskNo
      }
      const file = {
        fileUrl: fileUrl,
        fileName: 'countLoanDataWithDateExcelColor.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    VisualChart(arg2) {
      console.log('查看哪个图表？', this.queryParam)
      var paramsecharts = this.getQueryParams()
      this.paramsChartsData = paramsecharts
      paramsecharts.pageSize = 30
      console.log('调用弹窗时候的参数', paramsecharts)
      //判断有没有选新客
      if (this.queryParam.custType == 1 || this.queryParam.custType == 2) {
        if (this.queryParam.appssid == 1 || this.queryParam.appssid == 100 || this.queryParam.appssid == 101 || this.queryParam.appssid == 102 || this.queryParam.appssid == 103 || this.queryParam.appssid == 1102) {
          repaymentReportForProduct(Object.assign({}, paramsecharts)).then((res) => {
            if (res.code === 1000) {
              console.log('准备发数据咯！', res)
              if (res.data.rows.list.length) {
                // 提取日期并去重
                const uniqueDates = [...new Set(res.data.rows.list.map(item => item.endDate))]
                // 统计日期数量
                const dateCount = uniqueDates.length
                console.log(`不同日期的数量: ${dateCount}`)
                console.log(`日期列表: ${uniqueDates}`)
                if (dateCount > 7) {
                  this.$message.error('最多支持查看七天数据!')
                } else {
                  console.log('可以打开弹窗了调用弹窗时候的参数--->', paramsecharts)
                  this.$refs.repaymentReportForProductModal.sendRequest(paramsecharts)
                  this.$refs.repaymentReportForProductModal.openModal()
                  this.$refs.repaymentReportForProductModal.clearEcharts()
                }
              } else {
                this.$message.error('查到0条数据!')
              }
            } else {
            }

          }).catch(e => {

          })
        } else {
          this.$message.error('请选择盘号！') //单选 盘号 必选
        }
      } else {
        this.$message.error('请选择用户类型！') //用户类型 必须选一个
      }
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
